/**
 * «Магазин нагород»: sparks (✨ «іскри») are earned for effort only — homework handed in on time,
 * the riddle of the day, a review card, one's part of the class season, a missed lesson caught up,
 * an НМТ practice — and spent on looks of one's own pages: a frame for the animal, the sky of the
 * home page, a buddy sticker. A grade cannot be bought; there is no ranking: the sparks are seen by
 * the student and the family only.
 *
 * The same numbers live in the database (supabase/migrations/…_rewards.sql); a database test keeps
 * them in step.
 */

/** Sparks for one deed of effort. */
export const REWARD_POINTS = {
  homework: 3,
  puzzle: 1,
  review: 1,
  season: 5,
  catchUp: 2,
  nmt: 2,
} as const;

export type RewardSource = keyof typeof REWARD_POINTS;
export type RewardSlot = 'frame' | 'sky' | 'buddy';

export interface RewardItem {
  id: string;
  slot: RewardSlot;
  name: string;
  price: number;
}

export const REWARD_ITEMS: readonly RewardItem[] = [
  { id: 'frame-mint', slot: 'frame', name: 'М’ятна рамка', price: 10 },
  { id: 'frame-coral', slot: 'frame', name: 'Коралова рамка', price: 10 },
  { id: 'frame-sky', slot: 'frame', name: 'Небесна рамка', price: 10 },
  { id: 'frame-gold', slot: 'frame', name: 'Золота рамка', price: 20 },
  { id: 'frame-rainbow', slot: 'frame', name: 'Веселкова рамка', price: 30 },
  { id: 'sky-dawn', slot: 'sky', name: 'Світанок', price: 25 },
  { id: 'sky-mint', slot: 'sky', name: 'М’ятний ранок', price: 25 },
  { id: 'sky-lavender', slot: 'sky', name: 'Лавандовий вечір', price: 30 },
  { id: 'sky-sunset', slot: 'sky', name: 'Захід сонця', price: 30 },
  { id: 'sky-aurora', slot: 'sky', name: 'Північне сяйво', price: 40 },
  { id: 'buddy-seedling', slot: 'buddy', name: 'Паросток', price: 10 },
  { id: 'buddy-music', slot: 'buddy', name: 'Ноти', price: 10 },
  { id: 'buddy-ball', slot: 'buddy', name: 'М’яч', price: 10 },
  { id: 'buddy-palette', slot: 'buddy', name: 'Палітра', price: 10 },
  { id: 'buddy-rocket', slot: 'buddy', name: 'Ракета', price: 15 },
  { id: 'buddy-rainbow', slot: 'buddy', name: 'Веселка', price: 15 },
  { id: 'buddy-atom', slot: 'buddy', name: 'Атом', price: 15 },
  { id: 'buddy-telescope', slot: 'buddy', name: 'Телескоп', price: 15 },
  { id: 'buddy-sunglasses', slot: 'buddy', name: 'Крутий смайлик', price: 20 },
  { id: 'buddy-crown', slot: 'buddy', name: 'Корона', price: 25 },
];

export const rewardItem = (id: string | null | undefined) => REWARD_ITEMS.find((i) => i.id === id);
